import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { SelectStoreScreen } from 'modules/Auth/screens/SelectStore';
import { MigrationScreen } from 'modules/BundleMigration/screens/MigrationScreen';
import { ReadyAccountScreen } from 'navigation/components/ReadyAccountScreen';
import { DeviceNavigator } from 'navigation/DeviceNavigator';
import { BundleMigrationSelectors } from 'store/BundleMigration';
import { useAppSelector } from 'store/hooks';
import { IS_LEGACY_BUILD } from 'util/helpers';
import {
  useDeviceHeaders,
  useHasNonLegacyAppInstalled,
  useResetMigrationDismissal,
} from 'util/hooks';

import { UserSelectors } from '../store/User';
import { AuthenticationNavigator } from './AuthenticationNavigator';
import { RouteNames } from './linkingConfig';
import { useSetupMaxGridColum } from './useSetupMaxGridColumn';

const Stack = createNativeStackNavigator();

const RootRouter = () => {
  const isAuthenticated = useAppSelector(UserSelectors.selectIsAuthenticated);
  const isAuthenticationInProgress = useAppSelector(
    UserSelectors.selectIsAuthenticationInProgress,
  );
  const selectedAccountReady = useAppSelector(
    UserSelectors.selectSelectedAccountReady,
  );
  const account = useAppSelector(UserSelectors.selectAccount);
  const hasNonLegacyAppInstalled = useHasNonLegacyAppInstalled();
  const migrationDismissed = useAppSelector(
    BundleMigrationSelectors.selectIsDismissed,
  );
  useResetMigrationDismissal();

  useDeviceHeaders();

  useSetupMaxGridColum();

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {IS_LEGACY_BUILD && hasNonLegacyAppInstalled && !migrationDismissed ? (
        <Stack.Screen
          name={RouteNames.BundleMigration._}
          component={MigrationScreen}
        />
      ) : isAuthenticated ? (
        selectedAccountReady ? (
          <Stack.Screen name={RouteNames.Home._} component={DeviceNavigator} />
        ) : (
          <Stack.Screen
            name={RouteNames.ReadyAccount._}
            component={ReadyAccountScreen}
          />
        )
      ) : isAuthenticationInProgress && !account ? (
        <Stack.Screen
          name={RouteNames.SelectStore._}
          component={SelectStoreScreen}
        />
      ) : (
        <Stack.Screen
          name={RouteNames.Auth._}
          component={AuthenticationNavigator}
          options={{
            animationTypeForReplace: !isAuthenticated ? 'pop' : 'push',
          }}
        />
      )}
    </Stack.Navigator>
  );
};

export default RootRouter;
